import {
  MdReceipt,
  MdAttachMoney,
  MdPaid,
  MdCalendarMonth,
} from "react-icons/md";

const InvoiceHeader = ({ id, month, year, amount, status, monthYear }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      Paid: {
        bg: "bg-green-500/20",
        text: "text-green-400",
        border: "border-green-500",
        dot: "bg-green-500",
      },
      Pending: {
        bg: "bg-yellow-500/20",
        text: "text-yellow-400",
        border: "border-yellow-500",
        dot: "bg-yellow-500",
      },
      Failed: {
        bg: "bg-red-500/20",
        text: "text-red-400",
        border: "border-red-500",
        dot: "bg-red-500",
      },
      Unpaid: {
        bg: "bg-orange-500/20",
        text: "text-orange-400",
        border: "border-orange-500",
        dot: "bg-orange-500",
      },
    };
    const color = statusColors[status] || {
      bg: "bg-gray-500/20",
      text: "text-gray-400",
      border: "border-gray-500",
      dot: "bg-gray-500",
    };
    return (
      <div
        className={`flex items-center gap-2 px-3 py-1.5 rounded-full ${color.bg} ${color.text} border ${color.border}`}
      >
        <div className={`w-2 h-2 rounded-full ${color.dot}`}></div>
        <span className="text-xs font-medium">{status}</span>
      </div>
    );
  };

  return (
    <div className="bg-primary-dark rounded-2xl border border-gray-700/50 overflow-hidden mb-8 hover:border-primary-cyan/30 transition-all duration-300">
      {/* Top Section with Invoice Info Grid */}
      <div className="p-6 pb-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Invoice ID */}
          <div className="flex items-start gap-3 p-4 bg-gray-800/30 rounded-xl border border-gray-700/30">
            <div className="p-2 bg-primary-cyan/10 rounded-lg">
              <MdReceipt className="text-primary-cyan text-xl" />
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">
                Invoice ID
              </p>
              <p className="text-white font-mono text-sm font-semibold">{id}</p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-4 bg-gray-800/30 rounded-xl border border-gray-700/30">
            <div className="p-2 bg-primary-cyan/10 rounded-lg">
              <MdCalendarMonth className="text-primary-cyan text-xl" />
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">
                Billing Period
              </p>
              <p className="text-white text-sm font-semibold">
                {monthYear || `${month}/${year}`}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-4 bg-gray-800/30 rounded-xl border border-gray-700/30">
            <div className="p-2 bg-primary-cyan/10 rounded-lg">
              <MdPaid className="text-primary-cyan text-xl" />
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">
                Payment Status
              </p>
              <div>{getStatusBadge(status)}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative my-4 px-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-700/50"></div>
        </div>
      </div>

      <div className="p-6 pt-0">
        <div className="bg-gradient-to-br from-primary-cyan/5 via-transparent to-transparent rounded-xl p-6 border border-primary-cyan/20">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-6">
            {/* Total Amount */}
            <div className="flex items-center gap-4">
              <div className="p-3 bg-primary-cyan/20 rounded-full">
                <MdAttachMoney className="text-primary-cyan text-3xl" />
              </div>
              <div>
                <p className="text-gray-400 text-sm uppercase tracking-wider mb-1">
                  Total Amount
                </p>
                <p className="text-white text-4xl font-bold tracking-tight">
                  {formatAmount(amount)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceHeader;
